// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.avatar[data-v-b543c8c2]{\n  height: 100px;\n}\n.el-divider__text[data-v-b543c8c2] {\n    font-weight: bold;\n    font-size: 16px;\n}\n", ""]);
// Exports
module.exports = exports;
